<nav class="navbar navbar-expand-lg navbar-light ">
    <a class="navbar-brand" href="#">
        <img src="assets/images/brand.png" class="imgg"></a>
</nav>
<div class="mt-5 text-center">
    User is logged out successfully
</div>